export const PARK_DOCUMENT = "v1/park-document-headers";
export const POST_DOCUMENT = "v1/post-documents-headers";
export const PARK_POST_DOCUMENT = "v1/park-post-payment-documents";
export const PARK_DOCUMENT_LINE_ITEM = "v1/park-document-line-items";
export const ADMIN_DASHBOARD = "v1/admin-dashboard";
